import Global from "@/scripts/Global";
import {
    serverBus
} from "@/main";
import VueSignals from '@/scripts/VueSignals'
export default {
    name: 'RenameFF',
    data() {
        return {
            currData: {
                'ff_name': '',
                'ff_id': '',
                'ff_type': ''
            },
            new_ff_name: '',
            error: '',
        }
    },
    mounted() {
        this.currData = this.$parent.data
        this.new_ff_name = this.currData.ff_name

        serverBus.$on(VueSignals.EMPTY_FILE_RENAME_REASON_ERROR, (error) => {
            this.error = ''
        })

        serverBus.$on(VueSignals.FF_RENAME_ERROR_REASON, (error) => {
            if (error == 'ff_name_already_exists') {
                this.error = this.$t("Name already exists");
            }

            setTimeout(function() {
                Global.globalValue(VueSignals.EMPTY_FILE_RENAME_REASON_ERROR, true)
            }, 4000)
        })
    },
    methods: {
        RenameFF() {
            Global.globalValue(VueSignals.RENAME_FF, {
                "ff_id": this.currData.ff_id,
                "ff_name": this.new_ff_name.replace(/([<|>|/|\\|\||?|*|"|'])/g, "_"),
                "ff_type": this.currData.ff_type
            })
        }
    }
}
